export enum Enviroments {
  PRODUCTION = 'production',
  DEVELOPMENT = 'development'
}

export const ENVIROMENT =
  process.env.REACT_APP_TEST_URL === process.env.REACT_APP_PRODUCTION_URL
    ? Enviroments.PRODUCTION
    : Enviroments.DEVELOPMENT
